import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { listingInfiniteScrollActiveAtom } from '@/atoms/listing-infinite-scroll';

/**
 * Mirror whether this page's listing is in infinite-scroll mode with more
 * results still to fetch into `listingInfiniteScrollActiveAtom`, which
 * `AppContainer` reads to hide the site footer until the true end of the
 * results (group B of the show-more-infinite-scroll experiment).
 *
 * Pass `infiniteEngaged && hasNextPage`: the value flips back to `false` at
 * the true end so the footer returns. Cleared automatically on unmount so
 * navigating away never leaves the site in infinite mode.
 */
export const useListingInfiniteScrollActive = (active: boolean) => {
  const setActive = useSetAtom(listingInfiniteScrollActiveAtom);

  useEffect(() => {
    setActive(active);
  }, [active, setActive]);

  useEffect(
    () => () => {
      setActive(false);
    },
    [setActive]
  );
};
